import { PolicyService } from './../../../services/policy/policy.service';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { UtilityService } from 'src/app/services/utility/utility.service';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import { DialogCreaDestinatariPolicyComponent } from './dialog/dialog-crea-destinatari-policy/dialog-crea-destinatari-policy.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';

@Component({
  selector: 'app-cfg-destinatari-policy',
  templateUrl: './cfg-destinatari-policy.component.html',
  styleUrls: ['./cfg-destinatari-policy.component.scss'],
  standalone: false,
})
export class CfgDestinatariPolicyComponent {
  @ViewChild('tabella') tabella!: ListaTabellareComponent;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public filtri: Filtri[] = [
    {
      titolo: 'Destinatario',
      forControlName: 'descrizione',
      input: 'text',
    },
    {
      titolo: 'Descrizione attuazione',
      forControlName: 'lineaGuidaDestinatario',
      input: 'text',
    },
  ];

  public colonne: { [key: string]: Colonna } = {
    descrizione: {
      title: 'Descrizione',
      value: 'descrizione',
      sortable: true,
    },

    modifica: {
      type: 'button',
      buttonIcon: 'edit',
      title: 'Modifica',
      buttonId: 'modifica',
      buttonMostraSempre: true,
    },
    elimina: {
      type: 'button',
      buttonIcon: 'delete',
      title: 'Elimina',
      buttonId: 'elimina',
    },
  };
  constructor(
    public dialog: MatDialog,
    private utilityService: UtilityService,
    private policyService: PolicyService,
  ) {}

  public fnCaricamentoDati: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    if (!sortBy) {
      sortBy = [
        {
          chiave: 'descrizione',
          sort: 'asc',
        },
      ];
    }

    return this.policyService.getDestinatariPolicy(page, pageSize, ricerca, filters, sortBy);
  };

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.creaNuovo(event.data);
        break;
      case 'elimina':
        this.elimina(event.data.id);
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  creaNuovo(destinatarioPolicy?: any) {
    const dialogCreaDestinatarioPolicy = this.dialog.open(DialogCreaDestinatariPolicyComponent, {
      data: {
        destinatarioPolicy: destinatarioPolicy,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '75%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogCreaDestinatarioPolicy.afterClosed().subscribe((result) => {
      this.tabella.caricaDati();
    });
  }

  elimina(idRiga: string) {
    this.utilityService.openDialog({
      descrizione: 'Confermi di eliminare il destinatario Policy',
      bottoni: [
        {
          nome_btn: 'NO',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'SI',
          background_color: 'var(--mat-color-primary)',
          handler: () => {
            this.spinnerOver.show();
            this.policyService.deleteDestinatariPolicy(idRiga).subscribe({
              next: () => {
                this.tabella.caricaDati();
                this.spinnerOver.hide();
              },
              error: (err: any) => {
                this.spinnerOver.hide();
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: err.error.message,
                  bottoni: [
                    {
                      nome_btn: 'Chiudi',
                      handler: () => {
                        this.tabella.caricaDati();
                      },
                    },
                  ],
                });
              },
            });
          },
        },
      ],
    });
  }
}
